export default __webpack_public_path__ + "static/media/the-fmcg-group-image.8d5b3e7f.jpg";